var React = require('react');

function SChevronprevious18Light (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.999,9a1.23486,1.23486,0,0,1,.38531-.894l6.992-6.749A1.247,1.247,0,1,1,13.1297,3.13066L7.0467,9.00244l6.06317,5.84712A1.248,1.248,0,0,1,12.24912,17a1.20463,1.20463,0,0,1-.85765-.343l-7.01-6.75513A1.24976,1.24976,0,0,1,3.999,9Z","fill":"#fff"}));
}

SChevronprevious18Light.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SChevronprevious18Light;

SChevronprevious18Light.default = SChevronprevious18Light;
